import { PASSWORD_CHECK_PARAMS, PASSWORD_COMPLEXITY_CHECK_REGEXP } from "./appConstants";

export const checkIsPasswordValidWithParams = (password, paramsList) => {
    const complexityCheckParams = paramsList || Object.values(PASSWORD_CHECK_PARAMS);
    return !complexityCheckParams.some((param) => {
        const regexp = new RegExp(PASSWORD_COMPLEXITY_CHECK_REGEXP[param]);
        return !regexp.test(password);
    });
};